import { i18n } from '../plugins/i18n';
import { axios } from '@/plugins/axios';
import store from '../store';
import languages from '../util/languages';
import { mergeTranslations } from '../helpers/mergeTranslations';

const loadedLanguages = [import.meta.env.VITE_I18N_LOCALE];
const languagesAvailable = languages.availableLanguages;

class switchToLangOrCloserLang {
    static async handle(lang, venueId, accountId) {
        const userLanguage = lang || navigator.language;

        const langIfSupported = this.findMatchingLang(userLanguage);

        if (langIfSupported) {
            store.commit('customer/setLang', langIfSupported);

            return this._loadLanguageAsync(langIfSupported, venueId, accountId);
        }
        return;
    }

    static findMatchingLang(lang) {
        if (languagesAvailable.includes(lang)) {
            return lang;
        } else if (lang.includes('-')) {
            const userLanguageSplit = lang.split('-');

            if (languagesAvailable.includes(userLanguageSplit[0])) {
                return userLanguageSplit[0];
            }
        }

        return false;
    }

    static async loadBrowserLang() {
        const langIfSupported = this.findMatchingLang(
            window.navigator.language
        );
        if (langIfSupported) {
            const venueId = store.state.venue.venue?.id;
            const accountId = store.state.venue.venue?.accountId;
            await this.handle(langIfSupported, venueId, accountId);
        }
    }

    static async _setI18nLanguage(lang) {
        i18n.locale = lang;
        document.documentElement.setAttribute('lang', lang);
        axios.defaults.headers.common['Accept-Language'] =
            lang || import.meta.env.VITE_I18N_LOCALE || 'en';

        return lang;
    }

    static async _loadVenueOverrides(lang, venueId, accountId) {
        if (!lang || !venueId || !accountId) {
            return {};
        }

        const { data } = await axios.get(
            `/venues/${venueId}/translations/${lang}`,
            { params: { accountId } }
        );

        return data || {};
    }

    static async _loadLanguageAsync(lang, venueId, accountId) {
        let coreMsgs;

        if (loadedLanguages.includes(lang)) {
            coreMsgs = i18n.getLocaleMessage(lang);
        } else {
            const msgs = await import(`../lang/${lang}.json`);
            coreMsgs = msgs.default;
            loadedLanguages.push(lang);
        }

        const strings = await this._loadVenueOverrides(
            lang,
            venueId,
            accountId
        );

        const merged = mergeTranslations(coreMsgs, strings);
        i18n.setLocaleMessage(lang, merged);

        const menuId = store.state.venue.venue.menu?.[0]?.id;

        if (menuId) {
            const lng = lang.split('-');
            store.dispatch('menu/getMenuCategories', {
                id: menuId,
                lang: lng[0],
                silent: true
            });
        }

        return this._setI18nLanguage(lang);
    }
}

export default switchToLangOrCloserLang;
